import { ActionTypes as types } from '../constant';

let initialState = {
  featured: {
    seeMoreClicked: 0,
    charityResponse: {},
    clickedRadioBtn: true,
  },
  nearby: {
    seeMoreClicked: 0,
    charityResponse: {},
    clickedRadioBtn: true,
  },
  selectedCharity: false,
  selectedIndexCharityInfo: -1,
  selectedIndex: -1,
};

export default function charity(state = initialState, action) {
  // if state is not available, initial state is taken
  switch (action.type) {
    case types.CHARITY_SELECTED:
      const previousSourceData_charitySelected = state[action.data.source];
      const sourceDataCharitySelected = Object.assign(
        {},
        previousSourceData_charitySelected,
        {
          selectedCharity: true,
          selectedIndex: action.data.selectedIndx,
          clickedRadioBtn: true,
        }
      );
      const newState_charitySelected = Object.assign({}, state, {
        [action.data.source]: sourceDataCharitySelected,
      });
      return newState_charitySelected;
    case types.CHARITY_UNSELECTED:
      const previousSourceData_charityUnselected = state[action.data.source];
      const sourceData_charityUnselected = Object.assign(
        {},
        previousSourceData_charityUnselected,
        {
          selectedCharity: initialState.selectedCharity,
          selectedIndex: initialState.selectedIndex,
          clickedRadioBtn: false,
        }
      );
      const newState_charityUnselected = Object.assign({}, state, {
        [action.data.source]: sourceData_charityUnselected,
      });
      return newState_charityUnselected;
    case types.CHARITY_INFO_SELECTED:
      const previousSourceData_charityInfo = state[action.data.source];

      let actionDataSelectedIndexCharityInfo =
        action.data.selectedIndexCharityInfo;
      let stateSelectedIndexCharityInfo = state.selectedIndexCharityInfo;
      let selectedIndexCharityInfo;

      if (
        actionDataSelectedIndexCharityInfo === stateSelectedIndexCharityInfo
      ) {
        // if current state and selected state are same
        // then toggle
        selectedIndexCharityInfo = stateSelectedIndexCharityInfo === -1 ?
          actionDataSelectedIndexCharityInfo :
          -1;
      } else {
        // if current state (popover that is open)
        // and selected state (popover that is clicked) are not equal
        // then set the selectedCharityInfo to the one you clicked on.
        selectedIndexCharityInfo = actionDataSelectedIndexCharityInfo;
      }

      const sourceData_charityInfo = Object.assign(
        {},
        previousSourceData_charityInfo,
        {
          selectedIndexCharityInfo,
          charityResponse: action.data.charityResponse, // to send response to mobile tooltip
        }
      );

      const newState_charityInfo = Object.assign({}, state, {
        [action.data.source]: sourceData_charityInfo,
      });
      return newState_charityInfo;

    case types.CLOSE_POPOVER:
      const previousSourceData_closePopOver = state[action.data.source];
      const sourceData_closePopOver = Object.assign(
        {},
        previousSourceData_closePopOver,
        {
          selectedIndexCharityInfo: initialState.selectedIndexCharityInfo,
        }
      );
      const newState_closePopOver = Object.assign({}, state, {
        [action.data.source]: sourceData_closePopOver,
      });
      return newState_closePopOver;

    case types.SEE_MORE:
      const previousSourceData_seeMore = state[action.data.source];
      const sourceData_seeMore = Object.assign({}, previousSourceData_seeMore, {
        seeMoreClicked: state[action.data.source].seeMoreClicked + 1,
      });
      const newState_seeMore = Object.assign({}, state, {
        [action.data.source]: sourceData_seeMore,
      });
      return newState_seeMore;

    default:
      return state;
  }
}
